module.exports = __webpack_public_path__ + "assets/close-black-d0065a.svg";